import { AssetPermissionsDto } from '@api/Api';
import useTypedSelector from '@hooks/useTypedSelector';

type TPermissionName = keyof AssetPermissionsDto;

function useAssetMVPermissions(permissionName: TPermissionName): any {
  const asset = useTypedSelector(({ mediaViewer }) => mediaViewer.assets);
  const assetPermissions: AssetPermissionsDto | null =
    asset?.asset?.permissions || null;
  return assetPermissions?.[permissionName] || false;
}

export default useAssetMVPermissions;
